import { useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, CartesianGrid } from "recharts";
import { inr, fmtDate } from "../lib/api";
import { short } from "./BooksChart";

const COLORS = ["#60a5fa", "#fbbf24", "#34d399", "#f472b6", "#a78bfa", "#22d3ee", "#fb923c", "#f87171"];

export const BranchCompareChart = ({ entries, branches }) => {
  const [type, setType] = useState("deposit");
  const byDay = {};
  entries.filter((e) => e.type === type).forEach((e) => {
    const d = (byDay[e.date] ||= { date: e.date, label: fmtDate(e.date).slice(0, 5) });
    d[e.branch_id] = (d[e.branch_id] || 0) + e.amount;
  });
  const data = Object.keys(byDay).sort().map((k) => byDay[k]);
  return (
    <div className="rounded-2xl border border-line bg-surface p-4 sm:p-6" data-testid="branch-compare-chart">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-4">
        <h2 className="font-display text-base md:text-lg font-semibold">Branch Comparison Chart</h2>
        <div className="flex border border-line2">
          {["deposit", "withdraw"].map((t) => (
            <button key={t} onClick={() => setType(t)} data-testid={`branch-chart-toggle-${t}`}
              className={`px-3 py-1.5 text-sm capitalize transition-colors ${type === t ? (t === "deposit" ? "bg-emerald-600 text-white" : "bg-red-600 text-white") : "hover:bg-hover"}`}>{t}</button>
          ))}
        </div>
      </div>
      {data.length === 0 ? (
        <p className="text-sm text-muted-c py-10 text-center" data-testid="branch-chart-empty">No {type} entries in this period</p>
      ) : (
        <div className="h-72">
          <ResponsiveContainer width="100%" height="100%" minWidth={200} minHeight={200}>
            <BarChart data={data} margin={{ top: 10, right: 8, left: 0, bottom: 0 }} barGap={3}>
              <CartesianGrid stroke="rgb(var(--t-line))" vertical={false} />
              <XAxis dataKey="label" tick={{ fill: "rgb(var(--t-brand))", fontSize: 12 }} axisLine={false} tickLine={false} />
              <YAxis tickFormatter={short} tick={{ fill: "rgb(var(--t-muted))", fontSize: 11 }} axisLine={false} tickLine={false} width={56} />
              <Tooltip cursor={{ fill: "rgb(var(--t-hover) / 0.5)" }} formatter={(v) => inr(v)} labelFormatter={(_, p) => (p?.[0] ? fmtDate(p[0].payload.date) : "")}
                contentStyle={{ background: "rgb(var(--t-surface))", border: "1px solid rgb(var(--t-line2))", borderRadius: 8, color: "rgb(var(--t-ink))" }} />
              <Legend wrapperStyle={{ fontSize: 12, color: "rgb(var(--t-ink2))" }} />
              {branches.map((b, i) => (
                <Bar key={b.id} dataKey={b.id} name={b.name} fill={COLORS[i % COLORS.length]} radius={[4, 4, 0, 0]} maxBarSize={36} />
              ))}
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};
